const RequiredLabel = () => {
    return (<b className="text-danger">
        *
    </b>);
}

export default RequiredLabel;